export default __webpack_public_path__ + "0773cf6830b9e17971330ba1cd388bec.svg";